module.exports = __webpack_public_path__ + "static/media/trainee.41fc195f.jpg";